import { render } from "./ButtonApp.vue?vue&type=template&id=aa274032"
import script from "./ButtonApp.vue?vue&type=script&lang=js"
export * from "./ButtonApp.vue?vue&type=script&lang=js"

import "./ButtonApp.vue?vue&type=style&index=0&id=aa274032&lang=css"

import exportComponent from "/home/nimens/projects/cafe-portos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__